import {UsersDataSource} from './users-list.datasource';
import {Component, ElementRef, OnInit, Renderer, ViewChild} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
import {AuthService} from '../../services/auth.service';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {tap} from 'rxjs/operators';
import {fromEvent} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { StatusChange } from 'src/app/model/status-change.modal';
import { RoleModal } from 'src/app/model/role.modal';
import { NgForm } from '@angular/forms';
import { ActionTypeEnum } from 'src/app/enum/action-type-enum.enum';
type RequestStatus = "Saving.." | "Done";
@Component({
  selector: 'app-user-listing',
  templateUrl: './user-listing.component.html',
  styleUrls: ['./user-listing.component.css']
})
export class UserListingComponent implements OnInit {
  clientId: any;
  modalRef: BsModalRef;
  userId: any;
  applicationModel: any;
  userAppsdataSource: MatTableDataSource<any>;
  firstchar: any;
  lastchar: any;
  label_css: string;
  status: string;
  signed_up: string;
  dropdownButtonTitle: string = 'Save';
  change_btn_css: string;
  btn_default_css="btn btn-primary btn-md"
  userAppsdataSource_noData: any;
  isSavingData: boolean = false;
  response: any = {};
  searchText:string='';
  searchField: string='';
  requestStatus: RequestStatus = "Done";
  private clientTimezone: any;
  constructor(
              private router: Router,
              private authService: AuthService,
              private toastrService: ToastrService,
              private activatedRoute: ActivatedRoute,
              private modalService: BsModalService,) {
    UserListingComponent.app_id = this.activatedRoute.snapshot.params['id'];
    this.org_id = localStorage.getItem('org_id');
    // this.listallUsersWithinOrg();
  }

  static app_id: any;
  userList: any = [];
  org_id: any;
  model: any = {};
  displayedColumns: string[] = ['name','username', 'email_id', 'latestLoginDate', 'status', 'Actions'];
  @ViewChild('dropdown') dropdown: ElementRef
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('input') input: ElementRef;
  resetModel: { newPassword: string, confirmPassword: string };
  userForm: StatusChange;
  isLoading: boolean;
  dataSource: any;
  defaultPageNumber = 1;
  defaultPageSize = 10;
  statusFilter = '';
  statusOptions = ['Activated', 'De-Activated', 'Suspended', 'Locked'];
  statusInfo = [{state: 'ACTIVATED', count: 0}, {state: 'DE-ACTIVATED', count: 0}, {
    state: 'Suspended',
    count: 0
  }, {state: 'Locked', count: 0}];
  isLoadingStats = false;
  hideConfirmPassword=true;
  hideNewPassword=true;
  roleModal = new RoleModal();
  hideUserView=false;
  // below two vars used for downloading reports
  searchFieldType : "email_id" | "status"=null;
  searchFieldValue : String="";
  //

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.hideUserView = params['hideUserView'];
      // Use the hideViewUser parameter as needed
    });
    this.dataSource = new UsersDataSource(this.authService);
    this.dataSource.listallUsersWithinOrg(this.org_id, this.defaultPageNumber, this.defaultPageSize);
    this.getUsersStats();
  }

  ngAfterViewInit(): void {
    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        tap((value: any) => {
          if (value.code == 'Enter' || value.target.value == '') {
            // this.statusFilter = '';
            this.paginator.pageIndex = 0;
            this.searchText=value.target.value;
            this.listallUsersWithinOrg(value.target.value,this.statusFilter);
          }
        })
      )
      .subscribe();
    this.sort.sortChange
      .subscribe((sort) => {
        this.defaultPageNumber = 1;
        this.paginator.pageIndex = 0;
        this.listallUsersWithinOrg(this.searchText,this.statusFilter);
      });
    this.paginator.page.pipe(
      tap(() => {
        this.listallUsersWithinOrg(this.searchText);
      })
    ).subscribe();
  }

  openModal(resetPasswordTemplate:any,element){
    this.userId=element._id;
    this.userForm = new StatusChange();
    this.resetModel = { newPassword: "", confirmPassword: "" }
    this.userForm.fileType = "-1";
    this.userForm.status = element.status;
    this.userForm.userId = element._id;
    this.model.email_id=element.email_id
    this.roleModal.fileType = "-1";
    this.roleModal.file = undefined;
    this.roleModal.reason = "";

    // this.user.email=element.email_id
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.resetModel={newPassword:"",confirmPassword:""}
    this.modalRef = this.modalService.show(resetPasswordTemplate,config);

  }
  resetPassword() {
    this.requestStatus = "Saving..";
    this.authService.ResetPassword(this.userId,this.org_id, this.resetModel).subscribe((res: any) => {
      if (!res.error) {
        this.toastrService.success("Password resetted successfully.");
        this.modalRef.hide();
        this.requestStatus = "Done";
        this.resetModel= {newPassword: "", confirmPassword: ""};
      }

    }, error => {
      this.toastrService.error(error.message);
      this.modalRef.hide();
      this.requestStatus = "Done";

    })
  }
  getuserbyId() {
    debugger;
    this.authService.getuserbyId(this.userId).subscribe((res) => {
      this.model = res;
      if (this.model.firstname && this.model.lastname) {
        this.firstchar = this.model.firstname.charAt(0).toUpperCase();
        this.lastchar = this.model.lastname.charAt(0).toUpperCase();
      }
    }, error => {
      console.log(error)
    },
      () => {

      })
  }
  changeButtonTitle(status) {
    if (status == "ACTIVATED") {
      this.dropdownButtonTitle = "Activate"
      this.change_btn_css = "btn btn-primary btn-md"
    }
    if (status == "DE-ACTIVATED") {
      this.dropdownButtonTitle = "Deactivate"
      this.change_btn_css = "btn btn-warning btn-md"
    }
    if (status == "LOCKED") {
      this.dropdownButtonTitle = "Block";
      this.change_btn_css = "btn btn-danger btn-md"

    }
    if (status == "SUSPENDED") {
      this.dropdownButtonTitle = "Suspend"
      this.change_btn_css = "btn btn-md"
    }
  }
  changeStatus(form: NgForm) {

    if (form.valid) {
      this.isSavingData = true
      this.userForm.actionType = ActionTypeEnum.STATUS_CHANGE;
      if (this.userForm.fileType == "application/rxd" || this.userForm.fileType == "-1") {
        delete this.roleModal.file;
      }
      this.authService.updateuserStatus(this.userForm).subscribe((res) => {
        this.response = res['actualStatus']

        if (this.response + "" == "LOCKED") {
          this.toastrService.error(this.model.email_id + ' has been LOCKED');
        }
        if (this.response + "" == "ACTIVATED") {
          this.toastrService.success(this.model.email_id + ' has been ACTIVATED');
        }
        if (this.response + "" == "DE-ACTIVATED") {
          this.toastrService.warning(this.model.email_id + ' has been DE-ACTIVATED');
        }
        if (this.response + "" == "SUSPENDED") {
          this.toastrService.info(this.model.email_id + ' has been SUSPENDED');
        }
        // else {
        //   this.toastrService.success(this.model.email_id + ' has been UnLOCKED');
        // }
        this.isSavingData = false
        this.listallUsersWithinOrg(this.searchField,this.searchText,false)
        this.getUsersStats();

      }, error => { this.isSavingData = false },

        () => {
          this.isSavingData = false
          this.modalRef.hide();
        })
    } else {
      console.log('This form', form)
    }
  }
  getFiles(event: any, type: any) {
    debugger;
    if (event.target.files.length > 0) {
      if (ActionTypeEnum[type] == ActionTypeEnum.STATUS_CHANGE.toString()) {
        {
          this.userForm.file = event.target.files[0];
          this.userForm.fileName = event.target.files[0].name;
        }
      }
      else if (ActionTypeEnum[type] == ActionTypeEnum.ROLE_UPDATE || ActionTypeEnum[type] == ActionTypeEnum.ROLE_DELETE) {
        this.roleModal.file = event.target.files[0];
        this.roleModal.fileName = event.target.files[0].name;
      }
    }

  }
  listallUsersWithinOrg(username:String=null,status:String=null,sort=true) {
    if(!sort){
      this.sort.active='';
      this.sort.direction='';
    }
    const pageNumber = this.paginator.pageIndex + 1;
    const pageSize = this.paginator.pageSize > this.defaultPageSize ? this.paginator.pageSize : this.defaultPageSize;
    this.dataSource.listallUsersWithinOrg(this.org_id, pageNumber, pageSize, this.sort.active, this.sort.direction, username,status);
  }

  adduser() {
    this.router.navigate(['/add-user'], {queryParams: {opt: 'add'}});
  }

  addRoute() {
    this.router.navigate(['add-user'], {queryParams: {opt: 'add', app_id: UserListingComponent.app_id}});
  }

  verify(userId) {
    Swal({
      title: 'Are you sure you want delete this user?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
      cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        Swal(
          'Deleted!',
          'User has been deleted.',
          'success'
        ).then(() => {
          // this should execute now
          this.authService.deleteUser(userId, localStorage.getItem('org_id'), {orginalClient: true}).subscribe((res) => {
            }, error => {
            },
            () => {
              // this.router.navigate(["/user-listing"])
             this.listallUsersWithinOrg(this.searchField,this.searchText,false)
            });
        });
      }

    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetFilters() {
    this.statusFilter = '';
    this.searchFieldType=null;
    this.searchFieldValue="";
    this.searchText=""
    this.listallUsersWithinOrg(null,null);
  }

  filterStatus() {
    // this.input.nativeElement.value = '';
    // this.searchText=this.statusFilter;
    this.searchField='status'
    this.listallUsersWithinOrg(this.searchText , this.statusFilter);
  }

  getUsersStats() {
    this.isLoadingStats = true;
    this.authService.getOrgUsersStats(this.org_id).subscribe(
      (response: any) => {
        this.statusInfo = response.data;

        this.isLoadingStats = false;
      },
      (err) => {
        this.toastrService.error(err.message);
        this.isLoadingStats = false;
      }
    );
  }

  getStatus(type) {
    // @ts-ignore
    return this.statusInfo.find((status) => {
      if (status.state != null) {
        return status.state.toLowerCase() === type.toLowerCase();

      } else {
        return {count: 0};
      }
    }) || {count: 0};
  }

  onStatusCick(status: string) {
    this.statusFilter = status;
    this.filterStatus();
  }
  downloadReport(fileType:string){
    if ('Intl' in window) {
      const resolvedOptions = Intl.DateTimeFormat().resolvedOptions();
      this.clientTimezone = resolvedOptions.timeZone;
      console.log('Client timezone:', this.clientTimezone);
    } else {
      console.log('Intl API not supported in this browser.');
      // You can implement a fallback logic if the Intl API is not supported in the browser.
      // For example, use the UTC offset from the server.
    }
    const fileUrl=`${environment.serverUrl}auth/listallusers-within-org/${this.org_id}?pageNumber=1&pageSize=${Number.MAX_SAFE_INTEGER}&sortField=null&sortType=null&username=${this.searchText}&status=${this.statusFilter}&fileType=${fileType}&tz=${this.clientTimezone}`;
    fetch(fileUrl, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(response => response.blob())
      .then(blob => {
        // Create a temporary URL for the file blob
        const downloadUrl = URL.createObjectURL(blob);

        // Create a temporary link element
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `user-report.${new Date}.${fileType}`;

        // Trigger the download
        link.click();
      })
      .catch(error => {
        console.error('Error downloading the file:', error);
      });
  }
  trimPastedValue(event) {
    var clipboardData = event.clipboardData;
    var pastedText = clipboardData.getData('text/plain');
    var trimmedText = pastedText.trim();

    event.preventDefault();
    document.execCommand('insertText', false, trimmedText);
  }
  search(){
    this.listallUsersWithinOrg(this.searchText,this.statusFilter)
  }
}
